import { resolveGameLocale, t, type Locale } from '../i18n/messages';
import { whenTranslationReady } from '../i18n/translations';
export function renderEntryFailure(error: unknown, locale: Locale = resolveGameLocale()): void {
  console.error('[entry] Failed to load the game module.', error);

  const root = document.querySelector<HTMLElement>('#game');

  if (root === null) {
    return;
  }

  root.replaceChildren();
  root.classList.remove('nem-loading-shell');
  root.setAttribute('aria-busy', 'false');
  const panel = document.createElement('div');
  panel.setAttribute('role', 'alert');
  panel.className = 'boot-error';
  // The failed module may own all game CSS. Recovery must remain readable without it.
  panel.style.cssText = 'box-sizing:border-box;position:fixed;inset:0;max-width:none;margin:0;display:grid;align-content:center;justify-items:start;gap:20px;padding:24px max(20px,env(safe-area-inset-right)) 24px max(20px,env(safe-area-inset-left));overflow:auto;background:#1d1f2b;color:#f4f2ed;font:16px/1.6 system-ui,sans-serif;';
  const title = document.createElement('h1');
  title.textContent = t(locale, 'title');
  title.style.cssText = 'margin:0;font-size:26px;line-height:1.3;';
  const message = document.createElement('p');
  message.textContent = t(locale, 'bootError');
  message.style.cssText = 'margin:0;max-width:480px;';
  const retry = document.createElement('a');
  // Keep the stage, shared puzzle and entry view on an explicit full reload.
  retry.href = location.href;
  retry.addEventListener('click', (event) => {
    event.preventDefault();
    location.reload();
  });
  retry.textContent = t(locale, 'reload');
  retry.className = 'nem-loading-retry';
  retry.style.cssText = 'display:inline-flex;align-items:center;justify-content:center;box-sizing:border-box;min-width:88px;min-height:44px;padding:10px 20px;border-radius:12px;background:#ffda57;color:#1d1f2b;text-decoration:none;font:inherit;font-weight:600;';
  panel.append(title, message, retry);
  root.append(panel);
  // English shows first when the language catalog has not arrived; repaint if it still can.
  void whenTranslationReady(locale).then((ready) => {
    if (ready && panel.isConnected) {
      title.textContent = t(locale, 'title');
      message.textContent = t(locale, 'bootError');
      retry.textContent = t(locale, 'reload');
    }
  });
}
